import { Component, OnInit } from '@angular/core';
import { ConfirmationService, } from 'primeng/api';
import { CoreService } from '../core/_services/core.services';
import { AlertasService } from '../core/_services/alerta.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ActivatedRoute, Router } from '@angular/router';
import { AppBreadcrumbService } from '../consola/app.breadcrumb.service';

@Component({
  selector: 'app-volumen-datos',
  templateUrl: './volumen-datos.component.html',
  styleUrls: ['./volumen-datos.component.scss']
})
export class VolumenDatosComponent implements OnInit {

  submitted: Boolean = false;
  cargandoListaVolumen: boolean = true;
  idConsulta: any;

  //lista de registros
  registrosLista: any = [];
  listaEstado: any = [];
  columnas: any = [];
  totalRecords = 0;
  crear: any = '';

  constructor(
    public coreService: CoreService,
    public spinner: NgxSpinnerService,
    public msj: AlertasService,
    private route: ActivatedRoute,
    public confirmationService: ConfirmationService,
    private breadCrumbService: AppBreadcrumbService
    ) {
    this.breadCrumbService.setItems([
      { label: 'Volumen de Datos' }
    ]);
  }

  ngOnInit(): void {
    if(this.route.snapshot){
      this.crear = this.route.snapshot;
    }

    this.totalRecords = 0;
    this.columnas = [
      { field: 'tipo_documento', header: 'Tipo Documento' },
      { field: 'fecha', header: 'Fecha' },
      { field: 'num_documentos', header: '# Documentos' },
      { field: 'volumen_datos', header: 'Volumen' },
    ];

    this.getListado();
  }

  /**
   * Listados
   */
  getListado() {
    this.cargandoListaVolumen = true;
    this.coreService.get('/volumen-datos').subscribe(
      (res: any[]) => {
        this.registrosLista = res;
        this.totalRecords = this.registrosLista.length;
        this.cargandoListaVolumen = false;
      },
      (err: any) => {
        this.cargandoListaVolumen = false;
        console.log(err);
      }
    )
  }

  /**
   * Acciones
   */
  exportar() {
    // let data = {
    //   crear: 1
    // }
    this.coreService.download('/exportar-volumen-datos').subscribe(
      (res: any) => {
          if(res.body.type != 'application/json'){
            let blob = new Blob([res.body], { type: res.headers.get('Content-Type') });
            let file = new File([blob], 'prueba.xlsx', { type: res.headers.get('Content-Type'), lastModified: Date.now() });
            var fileURL = URL.createObjectURL(file);
            //window.open(fileURL);
            var today = new Date();
            var dd = today.getDate();
            var mm = today.getMonth() + 1; //January is 0!
            var yyyy = today.getFullYear();
            var hora = today.getHours();
            var minutos = today.getMinutes();
            // let titulo = this.consultaActual.titulo.replace(/ /g, "");
            // console.log(this.consultaActual.titulo);
            var linkToFile = document.createElement('a');
            linkToFile.download = 'VOLUMEN_DATOS_D_'+dd+'-'+mm+'-'+yyyy+'H_'+hora+'-'+minutos+'.xlsx';
            linkToFile.href = fileURL;
            linkToFile.click();
            this.msj.info("Consulta ejecutada exitosamente");
          } else {
            this.msj.error("El archivo no se encontró");
          }

      },
      (err: any) => {
        if (err.errors.error !== undefined && err.errors.error !== null) {
          for (let index = 0; index < err.errors.error.length; index++) {
            this.msj.error(err.errors.error[index]);
          }
        }
      }
    )
  }
}